import { render, staticRenderFns } from "./xz-table.vue?vue&type=template&id=14d67564&scoped=true&"
import script from "./xz-table.vue?vue&type=script&lang=js&"
export * from "./xz-table.vue?vue&type=script&lang=js&"
import style0 from "./xz-table.vue?vue&type=style&index=0&id=14d67564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d67564",
  null
  
)

export default component.exports